import createPersistedState from "vuex-persistedstate";
import { createStore } from "vuex";
import basic from "./module/basic.module";
import cart from "./module/cart.module";
import userData from "./module/userData.module";
import auth from "./module/auth.module";
import order from "./module/order.module";
import product from "./module/product.module";
import coupon from "./module/coupon.module";
import line from "./module/line.module";
import spreadsheet from "./module/spreadsheet.module";
import payment from "./module/payment.module";
import point from "./module/point.module";
import storeMenu from "./module/storeMenu.module";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    basic,
    cart,
    userData,
    auth,
    order,
    product,
    coupon,
    line,
    spreadsheet,
    payment,
    point,
    storeMenu
  },
  plugins: [createPersistedState()]
});
